import { createSlice } from '@reduxjs/toolkit';
import { Indicator , IndicatorState } from './indicatorTypes';
import { fetchAllIndicator , createIndicator ,updateIndicator ,fetchIndicatorById ,deleteIndicator } from './indicatorAction';


const initialState : IndicatorState = {
    indicator : [],
    selectedindicator : undefined,
    loadingStates : {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
    },

}


const indicatorSlice = createSlice({
    name : 'indicatorgroup',
    initialState,
    reducers:{},
    extraReducers : (builder) =>{
        builder
            .addCase(createIndicator.pending, (state) => {
                                              state.loadingStates.create = true;
                                              state.errors.create = undefined;
                                          })
                                          .addCase(createIndicator.fulfilled, (state, action) => {
                                              state.loadingStates.create = false;
                                              state.indicator.push(action.payload);
                                          })
                                          .addCase(createIndicator.rejected, (state, action) => {
                                              state.loadingStates.create = false;
                                              state.errors.create = action.payload as string;
                                          })
                              
                                          // Update 
                                          .addCase(updateIndicator.pending, (state) => {
                                              state.loadingStates.update = true;
                                              state.errors.update = undefined;
                                          })
                                          .addCase(updateIndicator.fulfilled, (state, action) => {
                                              state.loadingStates.update = false;
                                              const index = state.indicator.findIndex((d : any) => d.Id === action.payload.Id);
                                              if (index !== -1) {
                                                  state.indicator[index] = action.payload;
                                              }
                                          })
                                          .addCase(updateIndicator .rejected, (state, action) => {
                                              state.loadingStates.update = false;
                                              state.errors.update = action.payload as string;
                                          })
                              
                                          // Delete 
                                          .addCase(deleteIndicator.pending, (state) => {
                                              state.loadingStates.delete = true;
                                              state.errors.delete = undefined;
                                          })
                                          .addCase(deleteIndicator.fulfilled, (state, action) => {
                                              state.loadingStates.delete = false;
                                              state.indicator = state.indicator.filter((d : any) => d.Id !== action.payload);
                                          })
                                          .addCase(deleteIndicator.rejected, (state, action) => {
                                              state.loadingStates.delete = false;
                                              state.errors.delete = action.payload as string;
                                          })
                              
                                          // Fetch  by ID
                                          .addCase(fetchIndicatorById.pending, (state) => {
                                              state.loadingStates.fetchById = true;
                                              state.errors.fetchById = undefined;
                                          })
                                          .addCase(fetchIndicatorById.fulfilled, (state, action) => {
                                              state.loadingStates.fetchById = false;
                                              state.selectedindicator = action.payload;
                                          })
                                          .addCase(fetchIndicatorById.rejected, (state, action) => {
                                              state.loadingStates.fetchById = false;
                                              state.errors.fetchById = action.payload as string;
                                          })
                              
                                          // Fetch All 
                                          .addCase(fetchAllIndicator.pending, (state) => {
                                              state.loadingStates.fetchAll = true;
                                              state.errors.fetchAll = undefined;
                                          })
                                          .addCase(fetchAllIndicator.fulfilled, (state, action) => {
                                              state.loadingStates.fetchAll = false;
                                              state.indicator = action.payload.data;
                                          })
                                          .addCase(fetchAllIndicator.rejected, (state, action) => {
                                              state.loadingStates.fetchAll = false;
                                              state.errors.fetchAll = action.payload as string;
                                          }); 
    }
})


export default indicatorSlice.reducer;